import React, { useMemo } from 'react';
import { Box, Paper, useTheme } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  ResponsiveContainer,
  Tooltip,
  LabelList,
} from 'recharts';
import PropTypes from 'prop-types';

const WallsSummary = ({ walls = [] }) => {
  const theme = useTheme();

  const gradeToNumber = (grade) => {
    if (!grade) return Number.NEGATIVE_INFINITY;
    const gradeStr = grade.toString().toLowerCase().trim();
    const gradeMap = {
      '4a': 4.0, '4a+': 4.2, '4b': 4.4, '4b+': 4.6, '4c': 4.8, '4c+': 5.0,
      '5a': 5.2, '5a+': 5.4, '5b': 5.6, '5b+': 5.8, '5c': 6.0, '5c+': 6.2,
      '6a': 6.4, '6a+': 6.6, '6b': 6.8, '6b+': 7.0, '6c': 7.2, '6c+': 7.4,
      '7a': 7.6, '7a+': 7.8, '7b': 8.0, '7b+': 8.2, '7c': 8.4, '7c+': 8.6,
      '8a': 8.8, '8a+': 9.0, '8b': 9.2, '8b+': 9.4, '8c': 9.6, '8c+': 9.8,
      '9a': 10.0,
    };
    return gradeMap[gradeStr] ?? Number.NEGATIVE_INFINITY;
  };

  const chartData = useMemo(() => {
    const counts = new Map();
    for (const wall of walls) {
      const grade = wall?.officialGrade;
      if (!grade) continue;
      const key = grade.toString().trim();
      counts.set(key, (counts.get(key) || 0) + 1);
    }
    return [...counts.entries()]
      .map(([grade, count]) => ({ grade, count, gradeNumber: gradeToNumber(grade) }))
      .filter((d) => d.gradeNumber !== Number.NEGATIVE_INFINITY)
      .sort((a, b) => a.gradeNumber - b.gradeNumber);
  }, [walls]);

  if (!chartData.length) return null;

  return (
    <Paper
      sx={{
        p: 3,
        mb: 3,
        bgcolor: 'transparent',
        border: 1,
        borderColor: 'divider',
        // boxShadow: 'none',
      }}
    >

      <Box sx={{ width: '100%', height: 260 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={chartData}
            margin={{ top: 10, right: 20, left: 10, bottom: 10 }}
          >
            
            <XAxis
              dataKey="grade"
              stroke={theme.palette.text.secondary}
              fontSize={12}
              interval={0}
            />
            {/* <YAxis
              allowDecimals={false}
              stroke={theme.palette.text.secondary}
              fontSize={12}
            /> */}

            {/* <Tooltip
              cursor={{ fill: theme.palette.action.hover }}
              contentStyle={{
                background: theme.palette.background.paper,
                border: `1px solid ${theme.palette.divider}`,
              }}
              labelStyle={{ color: theme.palette.text.primary }}
            /> */}
            <Bar dataKey="count" fill={theme.palette.primary.main} radius={[6, 6, 0, 0]}>
              <LabelList
                dataKey="count"
                position="top"
                fill={theme.palette.text.primary}
                fontSize={12}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Paper>
  );
};

export default WallsSummary;

WallsSummary.propTypes = {
  walls: PropTypes.array,
};
